import ContactManagement from "./contact-management";

export default ContactManagement;